import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from '@/theme/ThemeProvider'
import HeaderSearchList from './HeaderSearchList'
import { HeaderSearchSection, StyledInput } from './styles'
import {useWindowDimensions} from "@app/hooks";
import {CButton, CInput} from "@components/Common";
import {IconSearch, IconX} from "@tabler/icons-react";
import {theme} from "@/theme/theme.ts";

const HeaderSearch = () => {
  const { gray, textw, drawerBgColor } = useContext(ThemeContext).theme.COLORS
  const { theme } = useContext(ThemeContext)
  const { width } = useWindowDimensions()
  const [hidden, setHidden] = useState(false)

  const inputRef = useRef<HTMLInputElement>(null)
  const containerRef = useRef<HTMLInputElement>(null)
  const [text, setText] = useState('')
  const [focused, setFocused] = useState(false)
  const { t } = useTranslation()
  const handleChange = (event) => {
    setText(event.target.value)
  }
  const clearInput = () => {
    setText('')
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }
  const handleOutsideClick = event => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target)
    ) {
      setFocused(false)
    }
  }
  useEffect(() => {
    if (width < 900) {
      setHidden(false)
    } else if (width < 1200) {
      setHidden(true)
    } else {
      setHidden(false)
    }
  }, [width])
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick)
    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [])

  return (
    <HeaderSearchSection ref={containerRef}>
      <form>
        {hidden ? (
          <CButton
            icon={<IconSearch size={14} color={textw} />}
            onClick={() => {
              setHidden(false)
            }}
            style={{
              background: 'transparent',
              width: 25,
              height: 25,
              borderRadius: 50,
            }}
          />
        ) : (
          <StyledInput className={'inputWithIcon'}>
            <CInput
              ref={inputRef}
              placeholder={t('search')}
              value={text}
              type={'text'}
              onChange={handleChange}
              style={{
                height: 36,
                marginTop: 10,
                paddingLeft: 35,
                width: 200,
                color: textw,
                borderColor: focused ? '#F87943' : 'transparent',
                borderWidth: 1,
                transition: 'all 0.3s ease-out',
                overflow: 'hidden',
              }}
              onFocus={() => setFocused(true)}
            />
            {/* <div className="left-icon">
              <IconSearch size={14} color={'#BDBDBD'} />
            </div> */}
            {text?.length ? (
              <div className="right-icon" onClick={clearInput}>
                <IconX size={12} />
              </div>
            ) : null}
          </StyledInput>
        )}
      </form>
      {(focused && text )? <HeaderSearchList text={text} /> : null}
    </HeaderSearchSection>
  )
}

export default React.memo(HeaderSearch)
